/**
 * VizzEx Pro External App
 * Main application component with routing
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';

// Auth Pages
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import OAuthCallbackPage from './pages/auth/OAuthCallbackPage';
import MagicLinkPage from './pages/auth/MagicLinkPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import VerifyEmailPage from './pages/auth/VerifyEmailPage';
import InvitationPage from './pages/auth/InvitationPage';
import AutoLoginPage from './pages/auth/AutoLoginPage';
import ConnectHtmlSitePage from './pages/auth/ConnectHtmlSitePage';

// Dashboard Pages
import DashboardPage from './pages/dashboard/DashboardPage';
import LinksPage from './pages/dashboard/LinksPage';
import DraftLinksPage from './pages/dashboard/DraftLinksPage';
import ContentAnalysisPage from './pages/dashboard/ContentAnalysisPage';
import PostsAttentionPage from './pages/dashboard/PostsAttentionPage';
import ContentGapsPage from './pages/dashboard/ContentGapsPage';
import TeamMembersPage from './pages/dashboard/TeamMembersPage';
import SettingsPage from './pages/settings/SettingsPage';
import SchemaPage from './pages/schema/SchemaPage';
import PostFaqsPage from './pages/faqs/PostFaqsPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public auth routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          
          {/* OAuth callbacks */}
          <Route path="/oauth/callback/hubspot" element={<OAuthCallbackPage />} />
          
          {/* Magic link */}
          <Route path="/auth/magic-link" element={<MagicLinkPage />} />
          
          {/* Auto-login from HubSpot */}
          <Route path="/auth/auto-login" element={<AutoLoginPage />} />
          
          {/* Email verification */}
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          
          {/* Team invitation */}
          <Route path="/invite" element={<InvitationPage />} />

          {/* HTML/No-CMS site connection — accessible when authenticated OR not */}
          <Route path="/connect-html-site" element={<ConnectHtmlSitePage />} />
          
          {/* Protected routes */}
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/links" element={<LinksPage />} />
            <Route path="/draft-links" element={<DraftLinksPage />} />
            <Route path="/content-analysis" element={<ContentAnalysisPage />} />
            <Route path="/posts-attention" element={<PostsAttentionPage />} />
            <Route path="/content-gaps" element={<ContentGapsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/schema"   element={<SchemaPage />} />
            <Route path="/post-faqs" element={<PostFaqsPage />} />
            <Route path="/team"     element={<TeamMembersPage />} />
          </Route>

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
